import { useMemo, type FC } from 'react'
import { Icon } from '@iconify/react'
import { ensureKebabCase } from '@/utils/base'

export interface PlayProps {
  icon: string
}

export const LucideIcon: FC<PlayProps> = (props) => {
  const { icon } = props

  const kebabIcon = useMemo(() => ensureKebabCase(icon), [icon])

  return (
    <div className="relative flex items-center h-full rounded-xl bg-gray-800 px-4 py-2 overflow-hidden hover:bg-gray-700 transition-all duration-200 cursor-pointer group">
      <Icon
        icon={`lucide:${kebabIcon}`}
        width={32}
        height={32}
        className="text-gray-300"
      />
    </div>
  )
}
